import PhotographyDark from "./PhotographyDark.png";
import BasketballDark from "./BasketballDark.png";
import PaintingDark from "./PaintingDark.png";
import BadmintonDark from "./BadmintonDark.png";
import GuitarDark from "./GuitarDark.png";
import PianoDark from "./PianoDark.png";
import DrumsDark from "./DrumsDark.png";
import CyclingDark from "./CyclingDark.png";
import CrossDark from "./CrossDark.png";

const Images = {
  PhotographyDark: PhotographyDark,
  BasketballDark: BasketballDark,
  PaintingDark: PaintingDark,
  BadmintonDark: BadmintonDark,
  GuitarDark: GuitarDark,
  PianoDark: PianoDark,
  DrumsDark: DrumsDark,
  CyclingDark: CyclingDark,
  CrossDark: CrossDark,
};

export default Images;
